import { render } from "./RealtimeTable.vue?vue&type=template&id=c49d12c8&ts=true"
import script from "./RealtimeTable.vue?vue&type=script&lang=ts"
export * from "./RealtimeTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__